<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1f2937;
  line-height: 1.6;
}

#app {
  min-height: 100vh;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Element UI 按钮样式优化 */
.el-button--primary {
  background: rgb(63, 104, 179);
  border: none;
}

.el-button--primary:hover {
  background: rgb(52, 78, 120);
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.6s ease-out;
}

/* 视频播放器播放按钮居中 - 全局样式 */
.video-js .vjs-big-play-button {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
  margin-top: 0 !important;
  margin-left: 0 !important;
  width: 80px !important;
  height: 80px !important;
  border-radius: 50% !important;
  border: 3px solid rgba(255, 255, 255, 0.9) !important;
  background-color: rgba(0, 0, 0, 0.6) !important;
  line-height: 80px !important;
  font-size: 40px !important;
  transition: all 0.3s ease !important;
}

.video-js .vjs-big-play-button:hover {
  background-color: rgba(0, 0, 0, 0.8) !important;
  border-color: rgba(255, 255, 255, 1) !important;
  transform: translate(-50%, -50%) scale(1.1) !important;
}

/* 登录提醒弹窗 - 美化样式 */
.login-prompt-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(63, 104, 179, 0.2) !important;
}
.login-prompt-dialog .el-message-box__header {
  padding: 24px 24px 12px;
  border-bottom: none;
}
.login-prompt-dialog .el-message-box__title {
  font-size: 18px;
  font-weight: 600;
  color: rgb(63, 104, 179);
}
.login-prompt-dialog .el-message-box__content {
  padding: 20px 24px 24px;
}
.login-prompt-dialog .el-message-box__message {
  font-size: 15px;
  line-height: 1.6;
  color: #4b5563;
}
.login-prompt-dialog .el-message-box__btns {
  padding: 0 24px 24px;
}
.login-prompt-dialog .el-message-box__btns .el-button--primary {
  padding: 10px 28px;
  border-radius: 10px;
  font-weight: 500;
}
</style>

